import React from 'react';
import PropTypes from 'prop-types';

import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';

import EditIcon from '@mui/icons-material/Edit';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

import './EditButton.scss';

export default function EditButton({
  isEditing,
  setIsEditing,
  infoSaving,
  setInfoSaving,
  updateFunction,
  onStartEditing,
  onCancel,
}) {
  return (
    !isEditing && !infoSaving ? (
      <IconButton
        className="edit-btn"
        onClick={(e) => {
          e.stopPropagation();
          onStartEditing?.();
          setIsEditing(true);
        }}
      >
        <EditIcon />
      </IconButton>
    ) : (
      <div className="btns-container">
        <Button
          className="save-btn"
          onClick={(e) => {
            e.stopPropagation();
            if (!infoSaving) {
              setInfoSaving(true);
              updateFunction();
            }
          }}
          disabled={infoSaving}
        >
          {!infoSaving ? (
            <>
              <SaveOutlinedIcon />
              Save
            </>
          ) : (
            <>
              <div className="dots-circle-spinner" />
              Saving
            </>
          )}
        </Button>
       {!infoSaving && (
        <Button
          className="cancel-btn"
          onClick={(e) => {
            e.stopPropagation();
            onCancel?.();
            setIsEditing(false);
          }}
        >
          <CancelOutlinedIcon />
          Cancel
        </Button>
      )}
      </div>
    )
  );
}

EditButton.propTypes = {
  isEditing: PropTypes.bool,
  setIsEditing: PropTypes.func,
  infoSaving: PropTypes.bool,
  setInfoSaving: PropTypes.func,
  updateFunction: PropTypes.func,
  onStartEditing: PropTypes.func,
  onCancel: PropTypes.func,
};

EditButton.defaultProps = {
  isEditing: false,
  setIsEditing: () => { },
  infoSaving: false,
  setInfoSaving: () => { },
  updateFunction: () => { },
  onStartEditing: () => { },
  onCancel: () => { },
};
